// Module
var code = "<div class=\"rb-break rb-widget\"></div>";
// Exports
module.exports = code;